import { render, staticRenderFns } from "./variant.vue?vue&type=template&id=2a90f122&"
import script from "./variant.vue?vue&type=script&lang=js&"
export * from "./variant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a90f122')) {
      api.createRecord('2a90f122', component.options)
    } else {
      api.reload('2a90f122', component.options)
    }
    module.hot.accept("./variant.vue?vue&type=template&id=2a90f122&", function () {
      api.rerender('2a90f122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/variant.vue"
export default component.exports